module.exports = __webpack_public_path__ + "img/7c.1b355eca.png";